import { NgModule } from '@angular/core';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { RedeemConfirmDialogComponent } from './redeem-confirm-dialog/redeem-confirm-dialog.component';
import { AlertDialogNoOkBtnComponent } from './alert-dialog-no-ok-btn/alert-dialog-no-ok-btn.component';
import { DialogService } from './dialog.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NotifyDialogComponent } from './notify-dialog/notify-dialog.component';
import { MatRadioModule} from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatSelectModule} from '@angular/material/select';
import { MatInputModule} from '@angular/material/input';
import { MatFormFieldModule} from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatRadioModule,
        FormsModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
    ],
    declarations: [
        AlertDialogComponent,
        ConfirmDialogComponent,
        NotifyDialogComponent,
        RedeemConfirmDialogComponent,
        AlertDialogNoOkBtnComponent,
    ],
    providers: [
        DialogService,
    ],
    exports: [
        AlertDialogComponent,
        ConfirmDialogComponent,
        NotifyDialogComponent,
        RedeemConfirmDialogComponent,
        AlertDialogNoOkBtnComponent,
    ],
})
export class DialogModule {
}
